import { ReactNode } from 'react';

import {
  EOrganizedBy,
  ETimelineType,
  ETripEvent,
  IAccommodationEventData,
  IActivityEventData,
  IAreaEventData,
  IDatesRange,
  IDaysRange,
  IInformationEventData,
  ITarget,
  ITransferEventData,
  TFlightEventData,
  TTripEvent,
} from 'detailsv2/structure';

import { IAction } from '../ActionsMenu/types';

export interface IDay {
  /* day number */
  day: number;
  date: string | null;
  tripEvents: TDayTripEvent[];
}

export interface IDayTripEvent<K extends ETripEvent> {
  id: number;
  icon: string;
  type: K;
  /* position number inside the day */
  position: number;
  date: string | null;
  day: number;
  data: TripEventDataMap[K];
  attachedPages?: ITarget[];
  datesRange: IDatesRange;
  daysRange: IDaysRange;
  timelineType?: ETimelineType;
}

export type TDayTripEventCommon = {
  [K in ETripEvent]: IDayTripEvent<K>;
};

export type TDayTripEvent = TDayTripEventCommon[ETripEvent];

type TripEventDataMap = {
  [ETripEvent.Flight]: TFlightEventData;
  [ETripEvent.Transfer]: ITransferEventData;
  [ETripEvent.Area]: IAreaEventData | null;
  [ETripEvent.Accommodation]: IAccommodationEventData;
  [ETripEvent.Activity]: IActivityEventData;
  [ETripEvent.Information]: IInformationEventData;
};

export interface IDayProps {
  day: IDay;
}

export interface ITripEventCreateAction extends IAction {
  type?: ETripEvent;
}

export enum ETimelineWarningType {
  WRONG_FLIGHT_INFO = 'wrong_flight_info',
  EMPTY_DAYS = 'empty_days',
  RELEVANT_PRIMARY_PHOTO = 'relevant_primary_photo',
}

export interface ITimelineWarning {
  type: ETimelineWarningType;
  message: ReactNode;
}

export interface IInitialTimelineState {
  tripEvents: TTripEvent[];
  organizedBy: EOrganizedBy;
  collapsedDays: boolean;
}

export type TFavoriteIcons = {
  [K in ETripEvent]: string[];
};

export type TimeFormat = '12h' | '24h';
